<ng-container *ngIf="this.externalSettings">

  <nav [ngStyle]="UIUtilityService.getMobileViewMenuBackgroundStyle()" id="sidebar" 
    [ngClass]="{'active': this.isShowingSidebarNav, 'bg-menu-mobile-1stnational': !UIUtilityService.hasMobileViewMenuBackground()}">

    <div class="h-100 d-flex flex-column justify-content-between">

      <div class="mx-2" [ngClass]="PlatformService.isMobile() ? 'mt-5' : 'mt-3'">

        <div>
          <div id="sidebarDismiss" [ngClass]="PlatformService.isMobile() ? 'mt-5' : 'mt-3'">
            <mat-icon svgIcon="farAngleDoubleLeft" class="icon-white" (click)="this.sidebarDismiss()"></mat-icon>
          </div>
          <div>
            <p class="mobile-username">{{'SI_NAVBAR_WELCOME' | translate}}, {{ StringUtilityService.getCustomerFullName(internalSettings) }}</p>
          </div>
          <div>
            <p class="mobile-usertime">{{'LABEL_LAST_LOGIN' | translate}}: {{this.internalSettings.profile.dateAndTimeLastLogin}}</p>
          </div>
        </div>

        <div (click)="$event.stopPropagation()">
          <div>
            <mat-nav-list>
              <a class="px-0 py-4" mat-list-item *ngFor="let group of this.menu.getSectorGroup(PAMenuMobile.SECTOR_A)" (click)="sidebarDismissNav(group)">
                <div class="d-flex flex-row justify-content-between">
                  <div>
                    <img [src]="group.iconPath" class="img-icon-40 me-2" [alt]="group.title" />
                    <span class="mobile-title">{{ group.title | translate }}</span>
                  </div>
                  <app-personal-finance-management-header *ngIf="group.name == 'home'" (insightClick)="sidebarDismiss()"></app-personal-finance-management-header>
                </div>
              </a>
            </mat-nav-list>
          </div>
          <mat-divider></mat-divider>
          <div>
            <mat-nav-list>
              <a class="px-0 py-4" mat-list-item *ngFor="let group of this.menu.getSectorGroup(PAMenuMobile.SECTOR_B)" (click)="sidebarDismissNav(group)">
                <div class="d-flex flex-row justify-content-between">
                  <div>
                    <img [src]="group.iconPath" class="img-icon-40 me-2" [alt]="group.title" />
                    <span class="mobile-title">{{ group.title | translate }}</span>
                  </div>
                </div>
              </a>
            </mat-nav-list>
          </div>
        </div>

      </div>

      <div class="mb-2 d-flex flex-row justify-content-between">
        <div class="w-25 d-flex flex-row justify-content-between ms-2 mb-2">
          <button type="button" mat-button (click)="this.onSettingClick()"><img src="assets/images/icons/menu_settings.png" class="img-icon-40" alt="Settings"></button>
          <button type="button" mat-button (click)="this.onHelpCenterClick()"><img src="assets/images/icons/menu_help.png" class="img-icon-40" alt="Help"></button>
          <!-- <button type="button" mat-button (click)="this.onVoiceCommandClick()" *ngIf="this.isVoiceCommandEnabled" ><img src="assets/images/icons/menu_voice_command.png" class="img-icon-40" alt="Voice Command"></button> -->
          <button type="button" [ngStyle]="UIUtilityService.getVoiceCommandButtonStyle()" class="btn btn-white d-flex flex-row justify-content-center align-items-center px-2 py-1 ms-2"
              (click)="onVoiceCommandClick()" *ngIf="this.isVoiceCommandEnabled">
                <mat-icon svgIcon="farMicrophone" class="mx-auto my-1 icon-center voice-command-icon" [ngStyle]="UIUtilityService.getBankTextColor()"></mat-icon>
          </button>

        </div>
        <div class="w-75 d-flex justify-content-end">
          <button type="button" mat-button (click)="this.onLogoffClick()"><img src="assets/images/icons/menu_signout.png" class="mb-2 img-icon-40" alt="Signout"></button>
        </div>
      </div>
    </div>
  </nav>
</ng-container>